<template>
  <div>
    <slglrs-base-header-sec
      title="СЛУЖБЕНИ ГЛАСНИК РС"
      slug="NP"
    ></slglrs-base-header-sec>

    <div class="container-fluid base-container">
      <div class="tab-form sp_tab-form">
        <form class="w-100">
          <div class="row">
            <div
              v-if="issue !== null"
              class="col-lg-6 d-md-flex justify-content-between form-group_pr_1"
            >
              <div class="form-group form-group-sm ">
                <label class="form-label mb-px-15">Гласило</label>
                <div>
                  {{ issue.issueType }} {{ issue.numStr }}/{{ issue.year }}
                </div>
              </div>
              <div class="form-group form-group-sm">
                <label class="form-label mb-px-15">Датум</label>
                <div>
                  {{ issue.publishDateStr }}
                </div>
              </div>
              <div class="form-group form-group-sm">
                <label class="form-label mb-px-15">PDF</label>
                <div>
                  <!--                                    <router-link   :to="'/slglrs/viewActPdf/'+issue.id" target="_blank">-->
                  <!--                                    <span class="icon-file-pdf-o"></span>-->
                  <!--                                </router-link>-->
                  <!--                                    http://10.10.30.99:8080/SlGlasnikPortal/api/slglrs/pdf?id=22332-->
                  <router-link
                    v-if="canOpen === 'can_open'"
                    :to="'/slglrsViewPdf/' + issue.id"
                    target="_blank"
                   
                    @mousedown.native="isInternal && clickOnInternal($event)"
                  >
                    <span class="icon-file-pdf-o"></span>
                  </router-link>
                  <a
                    v-if="canOpen === 'not_logged_in'"
                    v-b-modal.login-modal
                    href="#"
                    @click.stop.prevent
                  >
                    <span class="icon-file-pdf-o"></span>
                  </a>
                  <a
                    v-if="canOpen === 'role_not_allowed'"
                    href="#"
                    @click.stop.prevent="role_not_allowed()"
                  >
                    <span class="icon-file-pdf-o"></span>
                  </a>
                  <!--                                    <a  :href="this.baseApiUrl + 'api/slglrs/pdf?id=' + issue.id" target="_blank">-->
                  <!--                                        <span class="icon-file-pdf-o"></span>-->
                  <!--                                    </a>-->
                </div>
              </div>
            </div>
            <div class="col-lg-6 d-md-flex justify-content-between">
              <div class="form-group form-group-sm mr-3">
                <label for="issue" class="form-label mb-px-10"
                  >Број/година</label
                >
                <select
                  id="issue"
                  v-model="issueIndex"
                  class="form-control full-width"
                >
                  <option
                    v-for="(item, index) in issues"
                    v-bind:key="index"
                    :value="index"
                  >
                    {{ item.num }}/{{ item.year }}
                  </option>
                </select>
              </div>
              <div
                class="form-group form-group-sm mr-3"
                v-if="documentType === 'law'"
              >
                <label class="form-label mb-px-10">Доносиоци</label>
                <select
                  v-model="authority"
                  class="form-control full-width"
                  @change="search"
                >
                  <option
                    v-for="item in filters.authorities"
                    v-bind:key="item.k"
                    :label="item.l"
                    :value="item.k"
                    >{{ item.l }}
                  </option>
                </select>
              </div>
              <div class="form-group form-group-sm mr-3">
                <label class="form-label">Врста документа</label>
                <div class="d-flex align-items-center">
                  <div>
                    <div class="form-check mr-3">
                      <input
                        type="radio"
                        id="customRadioInline1"
                        v-model="documentType"
                        class="form-check-input"
                        value="law"
                      />
                      <label class="form-check-label" for="customRadioInline1"
                        >прописи</label
                      >
                    </div>
                    <div class="form-check">
                      <input
                        type="radio"
                        id="customRadioInline2"
                        v-model="documentType"
                        class="form-check-input"
                        value="ad"
                      />
                      <label class="form-check-label" for="customRadioInline2"
                        >огласи</label
                      >
                    </div>
                  </div>
                  <select
                    id="vrsteDokumenata"
                    v-model="vrsteDokumenata"
                    class="form-control full-width"
                    @change="changeDocType()"
                  >
                    <option
                      v-for="item in docTypes"
                      v-bind:key="item.k"
                      :label="item.l"
                      :value="item.k"
                    >
                      {{ item.l }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="base-box base-box__accordion-sec d-flex">
        <div class=" accordion flex-fill" role="tablist">
          <div v-if="showLow">
            <b-card no-body class="ac_card">
              <b-card-header
                header-tag="header"
                class="ac_card-header"
                role="tab"
              >
                <b-button
                  class="btn btn-block accordion-title-btn text-uppercase"
                  variant="none"
                  block
                  href="#"
                  v-b-toggle="'accordion-low'"
                >
                  Закони, други прописи, општи и појединачни акти
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-low"
                :visible="true"
                class="ac_collapse scroll_to_collapse"
                role="tabpanel"
              >
                <b-card
                  no-body
                  v-for="(item, index) in searchResult"
                  v-bind:key="index"
                  class="ac_card"
                >
                  <b-card-header
                    header-tag="header"
                    class="ac_card-header-level-2"
                    role="tab"
                  >
                    <b-button
                      class="btn btn-block  accordion-title-btn-level-2"
                      variant="none"
                      block
                      href="#"
                      v-b-toggle="'accordion-' + item.docGroupId"
                    >
                      <!--                                            <span class="base-text-color mr-2">{{index+1 | romanize}}</span>-->
                      {{ item.docGroupName }}
                    </b-button>
                  </b-card-header>
                  <!--                        accordion="my-accordion"-->
                  <b-collapse
                    :id="'accordion-' + item.docGroupId"
                    :visible="true"
                    class="ac_collapse scroll_to_collapse"
                    role="tabpanel"
                  >
                    <ul class="ac_collapse__item-list-level-2">
                      <li
                        class="ac_collapse__item"
                        v-for="(child, index2) in item.items"
                        v-bind:key="index2"
                      >
                        <!--:to="'/slglrs/viewAct/'+child.id"-->
                        <router-link
                          class="ac_collapse__link-level-2 accordion-item-link "
                          v-if="canOpen === 'can_open'"
                          target="_blank"
                         
                          @mousedown.native="isInternal && clickOnInternal($event)"
                          :to="{ path: getRouterLink(child) }"
                        >
                          {{ child.name }}
                        </router-link>
                        <a
                          class="ac_collapse__link-level-2 accordion-item-link "
                          v-if="canOpen === 'not_logged_in'"
                          v-b-modal.login-modal
                          href="#"
                          @click.stop.prevent
                        >
                          {{ child.name }}
                        </a>
                        <a
                          class="ac_collapse__link-level-2 accordion-item-link "
                          v-if="canOpen === 'role_not_allowed'"
                          href="#"
                          @click.stop.prevent="role_not_allowed()"
                        >
                          <!--                                                    <span class="mr-2">{{index2+1}}.</span>-->
                          {{ child.name }}
                        </a>
                      </li>
                    </ul>
                  </b-collapse>
                </b-card>
              </b-collapse>
            </b-card>
          </div>
          <div v-if="showAdd">
            <b-card no-body class="ac_card">
              <b-card-header
                header-tag="header"
                class="ac_card-header"
                role="tab"
              >
                <b-button
                  class="btn btn-block accordion-title-btn text-uppercase"
                  variant="none"
                  block
                  href="#"
                  v-b-toggle="'accordion-adds'"
                >
                  ОГЛАСИ
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-adds"
                :visible="false"
                class="ac_collapse scroll_to_collapse"
                role="tabpanel"
              >
                <b-card
                  no-body
                  v-for="(item, index) in searchResultAdd"
                  v-bind:key="index"
                  class="ac_card"
                >
                  <b-card-header
                    header-tag="header"
                    class="ac_card-header"
                    role="tab"
                  >
                    <b-button
                      class="btn btn-block accordion-title-btn-level-2 btn-none collapsed"
                      variant="none"
                      block
                      href="#"
                      v-b-toggle="'accordion-' + item.docGroupId"
                    >
                      {{ item.docGroupName }}
                    </b-button>
                  </b-card-header>
                  <!-- accordion="add-accordion" -->
                  <b-collapse
                    :id="'accordion-' + item.docGroupId"
                    :visible="false"
                    class="ac_collapse scroll_to_collapse"
                    role="tabpanel"
                  >
                    <ul class="ac_collapse__item-list-level-2 ">
                      <li
                        class="ac_collapse__item"
                        v-for="(child, index2) in item.items"
                        v-bind:key="index2"
                      >
                        <router-link
                          v-if="canOpen === 'can_open'"
                          target="_blank"
                          :to="{ path: getRouterLink(child) }"
                         
                          @mousedown.native="isInternal && clickOnInternal($event)"
                          class="ac_collapse__link-level-2 accordion-item-link"
                          >{{ child.name }}</router-link
                        >
                        <a
                          v-else
                          v-b-modal.login-modal
                          class="ac_collapse__link-level-2 accordion-item-link  "
                        >
                          {{ child.name }}
                        </a>
                      </li>
                    </ul>
                  </b-collapse>
                </b-card>
              </b-collapse>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import SlglrsBaseHeaderSec from "@/base_pages/slglrs/SlglrsBaseHeaderSec.vue";


export default {
  name: "SlglrsNP_OverviewPage",
  data() {
    return {
      showLow: true,
      showAdd: true,
      // isActOpen: false,
      actHTML: "",
      itemList: [],
      baseApiUrl: window.env.VUE_APP_API_SLGL_DEV,

      isInternal: false,
      activeElement: null,

      documentType: null,

      issueIndex: 0,
      issue: null,
      issues: [],
      docTypes: [],
      lawDocTypes: [],
      adDocTypes: [],

      filters: {
        lawDocTypes: [],
        authorities: [],
        adDocTypes: [],
      },

      authority: null,
      vrsteDokumenata: null,

      searchResult: [],
      searchResultAdd: [],
      meta: {
        title: "Правно-информациони систем РС",
        description:
          "Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.",
        keywords:
          "zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik",
      },
    };
  },
  metaInfo() {
    return {
      title: this.meta.title,
      meta: [
        { name: "title", content: this.meta.title },
        { name: "description", content: this.meta.description },
        { name: "keywords", content: this.meta.keywords },
      ],
    };
  },
  components: {
    SlglrsBaseHeaderSec,
  },
  computed: {
    ...mapState(["userInfoState"]),
    canOpen() {
      if (this.userInfoState) {
        if (this.userInfoState.roles.includes("NP")) {
          return "can_open";
        } else {
          return "role_not_allowed";
        }
      } else {
        return "not_logged_in";
      }
    },
  },
  methods: {
    clickOnInternal(event) {
      // ako treba da bude crven samo zadnje kliknut
      //   if (this.activeElement) {
      //     this.activeElement.style.color = "";
      //   }
      if (event.button === 0 || event.button === 1) {
        this.activeElement = event.target;
        this.activeElement.style.color = "red";
      }
    },
    role_not_allowed() {
      alert("Немате приступ овој бази");
    },
    search() {
      if (this.$route.query.internal === "true") {
        axios
          .get(
            this.baseApiUrl +
              "Prins/internalOverviewSearch?" +
              "authorityId=" +
              this.authority +
              "&docType=" +
              this.documentType +
              "&docTypeFilterId=" +
              this.vrsteDokumenata +
              "&numberId=" +
              this.$route.params.numberId
          )
          .then((response) => {
            this.searchResult = response.data;
            // console.log(this.searchResult);
          });
      } else {
        axios
          .get(
            this.baseApiUrl +
              "Prins/overviewSearch?" +
              "authorityId=" +
              this.authority +
              "&docType=" +
              this.documentType +
              "&docTypeFilterId=" +
              this.vrsteDokumenata +
              "&numberId=" +
              this.issue.id
          )
          .then((response) => {
            this.searchResult = response.data;
            // console.log(this.searchResult);
          });
      }
    },
    fetchData() {
      var self = this;
      if (self.$route.query.internal === "true") {
        axios
          .get(
            this.baseApiUrl + "prins/number/find/" + this.$route.params.numberId
          )
          .then((response) => {
            self.issues = Array(response.data);
            self.issue = response.data;

            axios
              .get(
                self.baseApiUrl +
                  "Prins/InternalOverviewFilterInfoSlgl/" +
                  self.issue.id
              )
              .then((response) => {
                self.filters = response.data;
                self.documentType = "law";
                self.authority = self.filters.authorities[0].k;
              });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        axios
          .get(this.baseApiUrl + "Prins/GetAllPrinsNumbers/NP")
          .then((response) => {
            self.issues = response.data;
            if (self.issues.length > 0) {
              if (self.$route.params.numberId === "all") {
                self.issue = self.issues[self.issueIndex];
              } else {
                // console.log("this.$route.params.numberId: ", this.$route.params.numberId);
                for (let i = 0; i < self.issues.length; i++) {
                  if (self.issues[i].id == self.$route.params.numberId) {
                    self.issueIndex = i;
                    self.issue = self.issues[self.issueIndex];
                  }
                }
              }
              self.issue
                ? axios
                    .get(
                      self.baseApiUrl +
                        "Prins/OverviewFilterInfoSlgl/" +
                        self.issue.id
                    )
                    .then((response) => {
                      self.filters = response.data;
                      self.documentType = "law";
                      self.authority = self.filters.authorities[0].k;
                    })
                    .catch((error) => {
                      if (error.response.status === 404) {
                        window.location.href = "/";
                      }
                    })
                : (window.location.href = "/");
            }
          });
      }
    },
    fetchAdd() {
      if (this.$route.query.internal === "true") {
        axios
          .get(
            this.baseApiUrl +
              "Prins/internalOverviewSearch?" +
              "authorityId=" +
              this.authority +
              "&docType=" +
              "ad" +
              "&docTypeFilterId=" +
              this.vrsteDokumenata +
              "&numberId=" +
              this.$route.params.numberId
          )
          .then((response) => {
            this.searchResultAdd = response.data;
            if (this.searchResultAdd.length === 0) {
              this.showAdd = false;
            } else {
              this.showAdd = true;
            }
          });
      } else {
        axios
          .get(
            this.baseApiUrl +
              "Prins/overviewSearch?" +
              "authorityId=" +
              this.authority +
              "&docType=" +
              "ad" +
              "&docTypeFilterId=" +
              this.vrsteDokumenata +
              "&numberId=" +
              this.issue.id
          )
          .then((response) => {
            this.searchResultAdd = response.data;
            if (this.searchResultAdd.length === 0) {
              this.showAdd = false;
            } else {
              this.showAdd = true;
            }
          });
      }
    },
    changeDocType() {
      if (this.documentType === "law") {
        this.search();

        this.showAdd = this.vrsteDokumenata === -1;
      } else {
        this.fetchAdd();
      }
    },
    fetchFilterInfo() {
      this.issue = this.issues[this.issueIndex];
      axios
        .get(this.baseApiUrl + "Prins/OverviewFilterInfoSlgl/" + this.issue.id)
        .then((response) => {
          this.filters = response.data;
          this.authority = this.filters.authorities[0].k;
          if (this.documentType === "law") {
            this.docTypes = this.filters.lawDocTypes;
            this.showLow = true;
          } else {
            this.showLow = false;
            this.docTypes = this.filters.adDocTypes;
          }

          this.search();
          this.fetchAdd();
        });
    },
    getRouterLink(item) {
      return item.url != null
        ? `/slglrs/viewAct/${item.id}?internal=${this.isInternal}`
        : `/slglrsViewPdf/${item.ogNumberId}?internal=${this.isInternal}`;
    },
  },
  created() {
    if (this.$route.query.internal) this.isInternal = true;
    this.fetchData();
  },
  mounted() {},
  beforeCreate: function() {
    document.body.className = "color_slglrs";
  },
  watch: {
    documentType: function() {
      if (this.documentType === "law") {
        this.docTypes = this.filters.lawDocTypes;
        this.showLow = true;
      } else {
        this.showLow = false;
        this.docTypes = this.filters.adDocTypes;
      }
      this.vrsteDokumenata = this.docTypes[0].k;
      this.authority = this.filters.authorities[0].k;
      this.search();
      this.fetchAdd();
    },
    issueIndex: function() {
      this.documentType = "law";
      this.vrsteDokumenata = "-1";
      this.fetchFilterInfo();
    },
    // vrsteDokumenata: function () {
    //     // console.log("this.documentType: ",this.documentType);
    //     if (this.documentType === 'law') {
    //         this.search();
    //     } else {
    //         this.fetchAdd();
    //     }
    // }
  },
};
</script>

<style>
.main {
  background-color: #ddd !important;
  padding-bottom: 360px !important;
}

.tab-form {
  border-top: 1px solid #dee2e6;
}

.accordion .card .card-header .btn {
  padding: 12px 70px 12px 30px !important;
}

.btn:after {
  top: 50% !important;
  transform: translateY(-50%) !important;
}
</style>
